module.exports = __webpack_public_path__ + "img/15.c35e3ce8.png";